import { useEffect, useState } from 'react';

export function useMediaQuery(query: string) {
    const [ match, setMatch ] = useState(matchMedia(query).matches);

    useEffect(() => {
        let active = true;

        const queryList = matchMedia(query);

        const updateMatch = () => {
            if (active) {
                setMatch(queryList.matches);
            }
        };

        if ('addEventListener' in queryList) {
            queryList.addEventListener('change', updateMatch);
        } else {
            (queryList as MediaQueryList).addListener(updateMatch);
        }

        return () => {
            active = false;

            if ('removeEventListener' in queryList) {
                queryList.removeEventListener('change', updateMatch);
            } else {
                (queryList as MediaQueryList).removeListener(updateMatch);
            }
        };
    }, [ query ]);

    return match;
}
